import { footer } from "./Footer.module.css";

export function Footer() {
	return <div className={footer}>Copyright. 2025 Shinyaigeek</div>;
}
